// @flow
// $FlowFixMe
import React, { useEffect, useMemo } from "react";
import {
  // $FlowFixMe
  useNavigate,
  // $FlowFixMe
  useLocation
} from "react-router-dom";
import { get } from "lodash";

const RedirectPageMapping = {
  "/login": "/#login",
  "/join": "/#sign-up",
  "/registration": "/#sign-up",
  "/my-bets": "/#my-bets",
  "/deposit": "/#deposit",
  "/withdraw": "/#withdraw",
  "/info/privacypolicy": `/account#privacyPolicy`,
  "/info/termsandconditions": `/account#termsConditions`,
  "/info/accessibility": `/account#accessibility`,
  "/races": "/tracks"
};

const getPromosRedirectPath = (path, queryParams, toggles): string => {
  const showPromos =
    get(toggles, "enablePromosStoryblok", false) && path.startsWith("/promos");

  if (!showPromos) return "/";

  const promoPage = path.startsWith("/promos/")
    ? path.replace("/promos/", "")
    : "";
  const pathParams = promoPage
    ? `?promo=${promoPage}${queryParams.replace("?", "&")}`
    : queryParams;

  return `/${pathParams}#promos`;
};

type Props = {
  featureToggles: mixed,
  appVersion: boolean
};

// $FlowFixMe
const RedirectPage = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const queryParams = location.search;
  const toggles = get(props, "featureToggles");

  const redirectPath = useMemo(() => {
    return (
      RedirectPageMapping[currentPath] ||
      getPromosRedirectPath(currentPath, queryParams, toggles)
    );
  });

  useEffect(() => {
    navigate(redirectPath, { replace: true });
  }, [redirectPath]);

  return null;
};

export default RedirectPage;
